// Shared messenger button for the app header. Toggles `root._chatDrawerOpen`
// and, on open, bootstraps chat state via `@symbo.ls/collab-features` so the
// drawer renders immediately after. Unread badge is driven by the same
// package's `chat.unreadCount` helper; it lazy-loads once per app and
// caches the function on `root.__chatUnreadMod`.

export const Messenger = {
  tag: 'button',
  type: 'button',
  // smbls 3.14.x — FA-L11 fix landed; top-level `title` + `aria: { label }`
  // are now reliable on tag-typed elements (button/a/img/...). Previously
  // these required an `attr: { ... }` wrapper because per-tag
  // HTML_ATTRIBUTES dropped the global default attrs.
  title: 'Messenger',
  aria: { label: 'Messenger' },
  position: 'relative',
  padding: 'Z',
  round: 'Z',
  cursor: 'pointer',
  borderWidth: '0',
  background: (el, s) => (s.root?._chatDrawerOpen ? 'overlay' : 'transparent'),
  color: (el, s) => (s.root?._chatDrawerOpen ? 'title' : 'caption'),
  ':hover': { background: 'overlay', color: 'title' },

  onClick: async (e, el, s) => {
    const opening = !s.root._chatDrawerOpen
    s.root.update({ _chatDrawerOpen: opening })
    if (!opening) return
    const { chat } = await import('../collab-features/src/index.js')
    if (chat.bootstrapChatState) {
      await chat.bootstrapChatState(s.root)
    } else {
      const { data } = await chat.listChannels()
      const channels = data || []
      const active = channels[0]?.id || null
      s.root.update({
        _chatDrawerChannels: channels,
        _chatDrawerChannelId: active,
        _chatDrawerLoading: false
      })
      if (active) {
        const res = await chat.listMessages({ channelId: active, limit: 50 })
        s.root.update({ _chatDrawerMessages: (res.data || []).slice().reverse() })
      }
    }
  },

  // Lazy-load the unread helper once per app so the UnreadBadge factories
  // can compute synchronously from DOMQL.
  onRender: async (el, s) => {
    if (s.root?.__chatUnreadMod) return
    const { chat } = await import('../collab-features/src/index.js')
    s.root.update({ __chatUnreadMod: { unreadCount: chat.unreadCount } })
  },

  Icon: { icon: 'chat', boxSize: 'A A' },

  UnreadBadge: {
    if: (el, s) => {
      const { unreadCount } = s.root?.__chatUnreadMod || {}
      if (!unreadCount) return false
      return unreadCount({
        messagesByChannel: s.root?.messagesByChannel,
        channelMembers: s.root?.channelMembers,
        currentUserEmail: s.root?.currentUserEmail
      }) > 0
    },
    position: 'absolute',
    top: '0',
    right: '0',
    minWidth: 'Z',
    height: 'Z',
    padding: '0 V',
    round: 'C',
    background: 'red',
    color: 'white',
    fontSize: 'W',
    fontWeight: '700',
    lineHeight: '1',
    align: 'center center',
    pointerEvents: 'none',
    text: (el, s) => {
      const { unreadCount } = s.root?.__chatUnreadMod || {}
      if (!unreadCount) return ''
      const n = unreadCount({
        messagesByChannel: s.root?.messagesByChannel,
        channelMembers: s.root?.channelMembers,
        currentUserEmail: s.root?.currentUserEmail
      })
      return n > 99 ? '99+' : String(n)
    }
  }
}
